import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.blood_pressure
  },
  timeWindow: 7 * 12,
  childProps: {
    title: chartTitles.blood_pressure,
    legendEnabled: true,
    series: [
      {
        type: 'blood_pressure_upper',
        label: 'Upper (Systolic)'
      },
      {
        type: 'blood_pressure_lower',
        label: 'Lower (Diastolic)'
      }
    ],
    yAxisLabel: 'Blood Pressure (mmHg)'
  }
})
